import.meta.glob([
  '../images/**/*',
])

import './vendor/bootstrap';

document.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');

  if (window.scrollY > 0) {
    header.classList.add('site-header--scrolled');
  } else {
    header.classList.remove('site-header--scrolled');
  }
});

document.querySelectorAll('.nav-toggle').forEach((toggle) => {
  toggle.addEventListener('click', (event) => {
    event.preventDefault();

    const header = document.querySelector('.site-header');
    header.classList.toggle('site-header--open');
    toggle.classList.toggle('is-open');
  });
});

window.addEventListener('resize', () => {
    const header = document.querySelector('.site-header');
    header.classList.remove('site-header--open');
    document.querySelectorAll('.nav-toggle').forEach((toggle) => {
      toggle.classList.remove('is-open');
    });
});
